// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print {\n  .section {\n    padding-left: 0.7em;\n  }\n}\n", ""]);
// Exports
module.exports = exports;
